import { render } from "./ContactUsView.vue?vue&type=template&id=647d53f0&scoped=true&ts=true"
import script from "./ContactUsView.vue?vue&type=script&lang=ts"
export * from "./ContactUsView.vue?vue&type=script&lang=ts"

import "./ContactUsView.vue?vue&type=style&index=0&id=647d53f0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647d53f0"]])

export default __exports__